import { post } from "../AxiosConfig";

const URI = "/dashboard";

const listCounts = (payload) => {
  const URL = `${URI}/list-counts`;
  return post(URL, payload);
};

const getData = (payload) => {
  const URL = `${URI}/get-data`;
  return post(URL, payload);
};

const DashboardService = { listCounts, getData };

export default DashboardService;